import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "navbar navbar-expand-lg navbar-dark"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { class: "titre navbar-brand" }, "SIVERCOH", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "navbar-nav mx-auto custom-nav-center" }
const _hoisted_7 = { class: "logout navbar-nav ml-auto" }
const _hoisted_8 = {
  key: 1,
  id: "user",
  class: "user ml-5 mt-2 mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLogged)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
          _createVNode(_component_router_link, { to: { name: 'Home'} }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: { name: 'Requetes'},
                class: "nav-linkHome",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_button, { class: "liens mr-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Requêtes")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { name: 'jeuRequetes'},
                class: "nav-linkHome",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_button, { class: "liens mr-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Jeux de requêtes")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { name: 'lancement'},
                class: "nav-linkHome",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_button, { class: "liens mr-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Lancement")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { name: 'rapports'},
                class: "nav-linkHome",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_button, { class: "liens mr-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Rapports")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("ul", _hoisted_7, [
              _createVNode(_component_b_button, {
                id: "logout",
                class: "logout",
                type: "button",
                onClick: _ctx.logout
              }, {
                default: _withCtx(() => [
                  _createTextVNode("déconnexion")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLogged)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Bonjour " + _toDisplayString(_ctx.userName) + " " + _toDisplayString(_ctx.userFirstname), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}